import { useState, useEffect } from 'react';
import { get } from '../../../../../../services/request';
import { dangerNotification } from '../../../../../../services/notification';
import { InitInputValue } from '../aux';

interface OccupationResponse {
  id: string;
  nome: string;
  ativo: boolean;
}

interface Occupation {
  key: string | number;
  text: string;
  value: string;
}

export const useOccupations = (estateId: string, propertyType: string) => {
  const [occupations, setOccupations] = useState<Occupation[]>(InitInputValue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!estateId) {
      setOccupations([]);
      return;
    }

    const fetchOccupations = async () => {
      setLoading(true);
      setError(null);
      try {
        const response: OccupationResponse[] = await get(
          `/fire-insurance-quotations/segimob/domains/occupations?estateId=${estateId}`
        );
        const formattedOccupations = response.map(occupation => ({
          key: occupation.id,
          text: occupation.nome,
          value: occupation.id
        }));
        setOccupations(formattedOccupations);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err.message : String(err));
        dangerNotification('Erro', 'Não foi possível carregar as ocupações!');
      } finally {
        setLoading(false);
      }
    };

    fetchOccupations();
  }, [estateId]);

  return { occupations, loading, error };
};
